// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.screenfull-svg[data-v-43afc372] {\n  width: 17px;\n  height: 17px;\n  cursor: pointer;\n  fill: #606266;\n  vertical-align: middle;\n  margin-right: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
